import { render, staticRenderFns } from "./PresentDetail.vue?vue&type=template&id=1f6f4430&scoped=true&"
import script from "./PresentDetail.vue?vue&type=script&lang=js&"
export * from "./PresentDetail.vue?vue&type=script&lang=js&"
import style0 from "./PresentDetail.vue?vue&type=style&index=0&id=1f6f4430&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f6f4430",
  null
  
)

export default component.exports